import Types from '../types';

const INITIAL_STATE = {
  visible: false,
  severity: 'warning',
  message: '',
};

export default (reducerState = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.SHOW_ALERT_BANNER:
      return {
        ...reducerState,
        visible: true,
        severity: action.payload.severity || 'warning',
        message: action.payload.message,
      };
    case Types.HIDE_ALERT_BANNER:
      return {
        ...reducerState,
        visible: false,
        message: '',
      };
    default:
      return reducerState;
  }
};
